<template>
  <div class="card">
    <Loader>
      <div class="d-flex flex-column-fluid">
        <div class="container">
          <div class="card card-custom" >
            <div class="card-header py-3">
              <div class="card-title align-items-start flex-column">
                <h3 class="card-label font-weight-bolder text-dark"> {{role.name}}</h3>
              </div>
              <div class="card-toolbar"></div>
            </div>

            <div class="card-body mb-10" style="background-color: #0072CE0D;">
              <form class="form mb-4" v-for="(right, index) in rights" :key="index">
                  <h5 class="card shadow-sm p-3" style="width: 220px;">{{ right.name }} </h5>
                  <div class="row">
                    <div class="form-group col-12 col-md-6 col-lg-6" v-for="(item, key) in right.items" :key="key">
                      <div class="card shadow-sm p-3 col-12 mb-4">
                        <div class="row">
                          <label class="col-10 col-form-label">{{item.name }}</label>
                          <div class="col-2 switch-btn mt-3">
                            <span class="switch switch-icon">
                              <label>
                                <div class="form-check form-switch form-check-custom form-check-solid">
                                  <input
                                    class="form-check-input h-20px w-30px"
                                    type="checkbox"
                                    :name="item.value"
                                    :value="item.value"
                                    v-model="item.checked"
                                    @change="setPermission(item.checked, item.value)"
                                    id="flexSwitchChecked"
                                  />
                                </div>
                              </label>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>

<script setup>
import Loader from '@/components/Loader.vue'
import { useLocales } from '@/composables/locales'
import { computed, onMounted } from 'vue'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'


const route = useRoute()
const store = useStore()
const {locale} = useLocales()

const role = ref({})
const loading = ref(false)
const rights = ref([])

const allPermissions = computed(() => store.getters['permission/allPermissions'])


onMounted(async() => {
  await store.dispatch("permission/loadAllPermissions")
  if(route.name === 'settings-rights-view'){
    await fetchData()
  }
})

async function fetchData() {
  loading.value = true
  store.dispatch("role/getPermissionForProfile",route.params.id).then(response => {
    if (response.data) {
      let data = response.data
      let selected = response.data.permissions.map(permission => permission.name)
      role.value.name = data.name
      role.value.description = data.description
      role.value.permissions = selected

      rights.value = allPermissions.value.map(mod => {
          return {
            name: locale.value == 'fr' ? mod?.sub_module_fr : mod?.sub_module_en,
            items: mod?.permissions?.map(el => ({
              name: el[locale.value],
              value: el.value,
              checked: selected.includes(el.value)
            }))
          }
      })
    }
  })
  .finally(() => loading.value = false)

 
}
    
function setPermission(val, name) {
  let data = {value: val, input: name}
  store.dispatch("role/togglePermissionToProfile",{id: route.params.id, data: data})
  window.toastr['success'](i18n.global.t("notification.permission_added"))
}
  

</script>

<style scoped>
th,td {
  color: #181c32 !important;
  font-size: 14px;
}
.switch-btn{
  margin-top: 10px;
}
</style>
